import { Q } from "@nozbe/watermelondb";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useCallback, useRef } from "react";
import { SearchBar } from "@towersystems/roam-common-native";
import Product from "../../../../utilities/data/model/Product";
import { useFullTextSearchProvider } from "../../../../utilities/fulltext-search";
import { useAddCustomerToSale, useAddItem } from "../../utils/sale-controller";
import { TextInput } from "react-native";
import { useScheduler } from "../../../../utilities/scheduler";
import { useTranslation } from "react-i18next";
import {
  extractIdFromCustomerIdString,
  isCustomerIdString,
} from "@towersystems/roam-common/lib/shared-utils";

export interface ProductSearchProps {
  navigation: any;
  rightComponent?: React.ReactNode;
}

export const ProductSearch = ({
  navigation,
  rightComponent,
}: ProductSearchProps) => {
  const { t } = useTranslation("common");
  const searchInputRef = useRef<TextInput>();
  const { query, setQuery } = useFullTextSearchProvider();
  const { schedule } = useScheduler(100);
  const addItem = useAddItem({ navigation });
  const database = useDatabase();

  const handleOnProductSearchSubmit = useCallback(
    async (value?: string) => {
      if (value) {
        const isCustomerStr = isCustomerIdString(value);
        // if the value is a customer ID string, we should add the customer to the sale
        if (isCustomerStr) {
          const customerId = extractIdFromCustomerIdString(value);

          if (customerId) {
            return database
              .get("customers")
              .query(Q.where("retailer_id", Q.eq(customerId)))
              .fetch()
              .then(async (matchingCustomers) => {
                if (matchingCustomers.length > 0) {
                  navigation.navigate("ConfirmAddScannedCustomerModalScreen", {
                    customerId: customerId,
                  });
                  setQuery("");
                }
              })
              .catch((err) => console.log(err));
          }
        }

        return database
          .get<Product>("products")
          .query(Q.where("stock_number", Q.eq(value)))
          .fetch()
          .then(async (matchingProducts) => {
            if (matchingProducts.length > 0) {
              await addItem(matchingProducts[0].id);
              setQuery("");
            }
          })
          .catch((err) => console.log(err));
      }
    },
    [setQuery, addItem]
  );

  return (
    <SearchBar
      placeholder={t("search2")}
      onChange={(query) => setQuery(query)}
      value={query}
      selectTextOnFocus={true}
      onSubmitEditing={(v) =>
        handleOnProductSearchSubmit(v as string)?.then(() => {
          schedule(() => searchInputRef.current?.focus());
        })
      }
      rightComponent={!Boolean(query) && rightComponent}
      onCleared={() => searchInputRef.current?.focus()}
      ref={searchInputRef as any}
    ></SearchBar>
  );
};
